module.exports = __webpack_public_path__ + "static/location.6532d8df.svg";